module.exports = __webpack_public_path__ + "static/media/delegation-des-rh.35333915.jpg";